/*********************************************************
 *                  Admin gestion des licences devices
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminGestionLicenceDevicesCtrl", ["$scope", "$uibModal", "toastr", "DeviceService", "AdminLicencesService", "clients", "Utils",
		function ($scope, $uibModal, toastr, DeviceService, AdminLicencesService, clients, Utils) {

		var mapsModal, logsModal;

		$scope.showDevices = false;

		$scope.data = {
			clients: clients.data,
			centerMarker: [],
			createMarker: [],
			mobileLicence: []
		};

		$scope.clientSelected = function (client) {
			AdminLicencesService.getDevicesByClient(client.id)
				.then((response) => {
					$scope.data.devices = response.data;
					for (var i in $scope.data.devices) {
						var device = $scope.data.devices[i];
						$scope.data.createMarker[device.id] = createMarker(device);
						$scope.data.centerMarker[device.id] = centerMarker(device);
						getMobileLicences(device);
					}
					$scope.showDevices = true;
				})
				.catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la récupération des appareils.";
					if (data !== undefined && data.message) {
						errorMessage += " " + data.message;
					}
					toastr.error(errorMessage, "Erreur");
					$scope.showDevices = false;
				});
		};

		/**
		 * Récupérer les licences d'un appareil
		 * @param device
		 */
		function getMobileLicences(device) {
			AdminLicencesService.getMobileLicenceByClientInDevice($scope.data.currentClient.id, device.id)
				.then((response) => {
					$scope.data.mobileLicence[device.id] = response.data;
				}).catch((response) => {
					toastr.error(Utils.makeErrorMessage(response.data, "Impossible de récupérer les licences associées à l'appareil " + device.name), "Erreur");
				});
		}

		/**
		 * Position du téléphone sur une carte
		 *
		 * @param device
		 */
		$scope.openMapsModal = function (device) {
			$scope.data.deviceSelected = device;
			mapsModal = Utils.openModal($uibModal, "mapsModalTemplate.html", $scope);
		};

		/**
		 * Position du téléphone sur une carte
		 *
		 * @param device
		 */
		$scope.openDeviceLogs = function (device) {
			$scope.data.deviceSelected = device;
			DeviceService.getLogsDevice($scope.data.currentClient.id, device.id)
				.then((response) => {
					$scope.data.deviceSelected.logs = response.data;
				}).catch((response) => {
					toastr.error(Utils.makeErrorMessage(response.data, "Impossible de récupérer les logs de l'appareil " + device.name), "Erreur");
					logsModal.close();
				});
			logsModal = Utils.openModal($uibModal, "logsModalTemplate.html", $scope, "lg");
		};

		/**
		 * Centrer les markers
		 * @param device
		 * @returns {{lat: *, lng: *, zoom: number}}
		 */
		function centerMarker(device) {
			return {
				lat: device.lastConnectionLat,
				lng: device.lastConnectionLong,
				zoom: 17
			};
		}

		/**
		 * Montrer la carte pour l'appareil
		 * @param device
		 * @returns {boolean}
		 */
		$scope.deviceShowMap = function (device) {
			return (device.lastConnectionLat !== null && device.lastConnectionLong !== null)
				&& (device.lastConnectionLat !== 0 && device.lastConnectionLong !== 0);
		};

		/**
		 * Activer/Désactiver le mode débogage
		 * @param modeState
		 */
		$scope.deviceDebugModeChange = function (device, modeState) {
			device.debug = modeState;
			DeviceService.editDeviceForClient(device.id, device, $scope.data.currentClient.id).then((response) => {
				const data = response.data;
				toastr.success("", "L'appareil " + data.name + " a été mis à jour");
				$scope.clientSelected($scope.data.currentClient);
			}).catch((response) => {
				toastr.error(Utils.makeErrorMessage(response.data, "Problème lors de la mise à jour de l'appareil."), "Erreur");
			});
		};

		/**
		 * Créer un marker
		 * @param device
		 * @returns {{lat: *, lng: *, focus: boolean, message: string, draggable: boolean, icon: {type: string, icon: string, prefix: string, markerColor: string}}}
		 */
		function createMarker(device) {
			var object = {};
			object[device.id] = {
				lat: device.lastConnectionLat,
				lng: device.lastConnectionLong,
				focus: true,
				message: "Appareil " + device.name,
				draggable: false,
				icon: {
					type: "awesomeMarker",
					icon: "mobile",
					prefix: "fa",
					markerColor: "blue"
				}
			};
			return object;
		}

	}]);

